import { Navigate } from 'react-router-dom';

// Redirect old supplier-performance routes to new /suppliers/performance location
export const supplierPerformanceRoutes = [
  {
    path: 'supplier-performance',
    element: <Navigate to="/suppliers/performance" replace />,
  },
];
